import { buildExportTranscriptGroups, extractGroupText } from "./transcript.ts";

/**
 * Export chat history as markdown file.
 */
export function exportChatMarkdown(messages: unknown[], assistantName: string): void {
  const markdown = buildChatMarkdown(messages, assistantName);
  if (!markdown) {
    return;
  }
  const blob = new Blob([markdown], { type: "text/markdown" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `chat-${assistantName}-${Date.now()}.md`;
  link.click();
  URL.revokeObjectURL(url);
}

export function buildChatMarkdown(messages: unknown[], assistantName: string): string | null {
  const groups = buildExportTranscriptGroups(messages);
  if (groups.length === 0) {
    return null;
  }

  const lines: string[] = [`# Chat with ${assistantName}`, ""];
  for (const group of groups) {
    const role = group.role === "user" ? "You" : assistantName;
    const content = extractGroupText(group);
    if (!content.trim()) {
      continue;
    }
    const ts = typeof group.timestamp === "number" ? new Date(group.timestamp).toISOString() : "";
    lines.push(`## ${role}${ts ? ` (${ts})` : ""}`, "", content, "");
  }

  return lines.length > 2 ? lines.join("\n") : null;
}
